export function CalculatePolygonPerimeter(detail) {
  let points = detail.coordinates;
  let newArcData = detail.arcData;
  if (
    !(
      points[0][0] === points[points.length - 1][0] &&
      points[0][1] === points[points.length - 1][1]
    )
  )
    return 0;
  let perimeter = 0;
  let area = 0;
  let xSum = 0;
  let ySum = 0;
  for (let x = 0; x < points.length - 1; x++) {
    perimeter = perimeter + calculateLength(points[x], points[x + 1]);
    xSum = xSum + points[x][0] * points[x + 1][1];
    ySum = ySum + points[x][1] * points[x + 1][0];
  }
  area = Math.abs((xSum - ySum) / 2);
  for (let x = 0; x < newArcData.length; x++) {
    if (newArcData[x].type === 'carc' && newArcData[x].minor) {
      let dragcoords;
      if (x === newArcData.length - 1) {
        dragcoords = [
          [points[x - 1][0], points[x - 1][1]],
          [points[0][0], points[0][1]],
        ];
      } else {
        dragcoords = [
          [points[x][0], points[x][1]],
          [points[x + 1][0], points[x + 1][1]],
        ];
      }
      let draglength = calculateLength(dragcoords[0], dragcoords[1]);
      let arcPower = newArcData[x].power;
      let radius = Math.abs(arcPower / 4);
      let angle = Math.asin(draglength / (2 * radius)) * 2;
      perimeter =
        perimeter -
        calculateLength(points[x], points[x + 1]) +
        Math.PI * (2 * radius) * (angle / (2 * Math.PI));
      let fullCircleArea = Math.PI * radius * radius;
      let partialCircleArea = (angle / (2 * Math.PI)) * fullCircleArea;
      let p = (radius + radius + draglength) / 2;
      let innerTriangleArea = Math.sqrt(
        p * (p - radius) * (p - radius) * (p - draglength),
      );
      let circleSegmentArea =
        fullCircleArea - (partialCircleArea - innerTriangleArea);

      let arcControlCoords = [
        [
          (dragcoords[1][0] + dragcoords[0][0]) / 2,
          (dragcoords[1][1] + dragcoords[0][1]) / 2,
        ],
        [dragcoords[0][0], dragcoords[0][1]],
      ];
      arcControlCoords = [
        arcControlCoords[0],
        rotatePoint(
          arcControlCoords[0][0],
          arcControlCoords[0][1],
          arcControlCoords[1][0],
          arcControlCoords[1][1],
          -90,
        ),
      ];
      let arcControlFactor =
        dragcoords[0][0] === dragcoords[1][0] &&
        dragcoords[0][1] === dragcoords[1][1]
          ? 0
          : (arcPower > 0 ? 10 : -10) /
            Math.sqrt(
              Math.pow(
                Math.abs(arcControlCoords[0][0] - arcControlCoords[1][0]),
                2,
              ) +
                Math.pow(
                  Math.abs(arcControlCoords[0][1] - arcControlCoords[1][1]),
                  2,
                ),
            );
      arcControlCoords = [
        arcControlCoords[0],
        [
          arcControlCoords[0][0] +
            (arcControlCoords[1][0] - arcControlCoords[0][0]) *
              arcControlFactor,
          arcControlCoords[0][1] +
            (arcControlCoords[1][1] - arcControlCoords[0][1]) *
              arcControlFactor,
        ],
      ];
      let arcHeightCoords = [
        [dragcoords[1][0], dragcoords[1][1]],
        [
          (dragcoords[1][0] + dragcoords[0][0]) / 2,
          (dragcoords[1][1] + dragcoords[0][1]) / 2,
        ],
      ];
      arcHeightCoords = [
        arcHeightCoords[0],
        rotatePoint(
          arcHeightCoords[0][0],
          arcHeightCoords[0][1],
          arcHeightCoords[1][0],
          arcHeightCoords[1][1],
          -90,
        ),
      ];
      let arcHeightFactor =
        dragcoords[0][0] === dragcoords[1][0] &&
        dragcoords[0][1] === dragcoords[1][1]
          ? 0
          : radius /
            Math.sqrt(
              Math.pow(
                Math.abs(arcHeightCoords[0][0] - arcHeightCoords[1][0]),
                2,
              ) +
                Math.pow(
                  Math.abs(arcHeightCoords[0][1] - arcHeightCoords[1][1]),
                  2,
                ),
            );
      arcHeightCoords = [
        arcHeightCoords[0],
        [
          arcHeightCoords[0][0] +
            (arcHeightCoords[1][0] - arcHeightCoords[0][0]) * arcHeightFactor,
          arcHeightCoords[0][1] +
            (arcHeightCoords[1][1] - arcHeightCoords[0][1]) * arcHeightFactor,
        ],
      ];
      let controlPoint = [arcControlCoords[1][0], arcControlCoords[1][1]];
      if (!circleSegmentArea) {
      } else if (inPolygon(controlPoint, points)) {
        area = area - circleSegmentArea;
      } else {
        area = area + circleSegmentArea;
      }
    } else if (newArcData[x].type === 'carc') {
      let dragcoords;
      if (x === newArcData.length - 1) {
        dragcoords = [
          [points[x - 1][0], points[x - 1][1]],
          [points[0][0], points[0][1]],
        ];
      } else {
        dragcoords = [
          [points[x][0], points[x][1]],
          [points[x + 1][0], points[x + 1][1]],
        ];
      }
      let draglength = calculateLength(dragcoords[0], dragcoords[1]);
      let arcPower = newArcData[x].power;
      let radius = Math.abs(arcPower / 4);
      let angle = Math.asin(draglength / (2 * radius)) * 2;
      perimeter =
        perimeter -
        calculateLength(points[x], points[x + 1]) +
        Math.PI * (2 * radius) * ((Math.PI * 2 - angle) / (2 * Math.PI));
      let fullCircleArea = Math.PI * radius * radius;
      let partialCircleArea = (angle / (2 * Math.PI)) * fullCircleArea;
      let p = (radius + radius + draglength) / 2;
      let innerTriangleArea = Math.sqrt(
        p * (p - radius) * (p - radius) * (p - draglength),
      );
      let circleSegmentArea =
        fullCircleArea - (partialCircleArea - innerTriangleArea);

      let arcControlCoords = [
        [
          (dragcoords[1][0] + dragcoords[0][0]) / 2,
          (dragcoords[1][1] + dragcoords[0][1]) / 2,
        ],
        [dragcoords[0][0], dragcoords[0][1]],
      ];
      arcControlCoords = [
        arcControlCoords[0],
        rotatePoint(
          arcControlCoords[0][0],
          arcControlCoords[0][1],
          arcControlCoords[1][0],
          arcControlCoords[1][1],
          -90,
        ),
      ];
      let arcControlFactor =
        dragcoords[0][0] === dragcoords[1][0] &&
        dragcoords[0][1] === dragcoords[1][1]
          ? 0
          : (arcPower > 0 ? 10 : -10) /
            Math.sqrt(
              Math.pow(
                Math.abs(arcControlCoords[0][0] - arcControlCoords[1][0]),
                2,
              ) +
                Math.pow(
                  Math.abs(arcControlCoords[0][1] - arcControlCoords[1][1]),
                  2,
                ),
            );
      arcControlCoords = [
        arcControlCoords[0],
        [
          arcControlCoords[0][0] +
            (arcControlCoords[1][0] - arcControlCoords[0][0]) *
              arcControlFactor,
          arcControlCoords[0][1] +
            (arcControlCoords[1][1] - arcControlCoords[0][1]) *
              arcControlFactor,
        ],
      ];
      let arcHeightCoords = [
        [dragcoords[1][0], dragcoords[1][1]],
        [
          (dragcoords[1][0] + dragcoords[0][0]) / 2,
          (dragcoords[1][1] + dragcoords[0][1]) / 2,
        ],
      ];
      arcHeightCoords = [
        arcHeightCoords[0],
        rotatePoint(
          arcHeightCoords[0][0],
          arcHeightCoords[0][1],
          arcHeightCoords[1][0],
          arcHeightCoords[1][1],
          -90,
        ),
      ];
      let arcHeightFactor =
        dragcoords[0][0] === dragcoords[1][0] &&
        dragcoords[0][1] === dragcoords[1][1]
          ? 0
          : radius /
            Math.sqrt(
              Math.pow(
                Math.abs(arcHeightCoords[0][0] - arcHeightCoords[1][0]),
                2,
              ) +
                Math.pow(
                  Math.abs(arcHeightCoords[0][1] - arcHeightCoords[1][1]),
                  2,
                ),
            );
      arcHeightCoords = [
        arcHeightCoords[0],
        [
          arcHeightCoords[0][0] +
            (arcHeightCoords[1][0] - arcHeightCoords[0][0]) * arcHeightFactor,
          arcHeightCoords[0][1] +
            (arcHeightCoords[1][1] - arcHeightCoords[0][1]) * arcHeightFactor,
        ],
      ];
      let controlPoint = [arcControlCoords[1][0], arcControlCoords[1][1]];
      if (!circleSegmentArea) {
      } else if (inPolygon(controlPoint, points)) {
        area = area - circleSegmentArea;
      } else {
        area = area + circleSegmentArea;
      }
    } else if (newArcData[x]) {
      let dragcoords;
      if (x === newArcData.length - 1) {
        dragcoords = [
          [points[x - 1][0], points[x - 1][1]],
          [points[0][0], points[0][1]],
        ];
      } else {
        dragcoords = [
          [points[x][0], points[x][1]],
          [points[x + 1][0], points[x + 1][1]],
        ];
      }
      let arcPower = newArcData[x].power / 2;

      let arcHeight = arcPower / 2;

      let arcControlCoords = [
        [
          (dragcoords[1][0] + dragcoords[0][0]) / 2,
          (dragcoords[1][1] + dragcoords[0][1]) / 2,
        ],
        [dragcoords[0][0], dragcoords[0][1]],
      ];
      arcControlCoords = [
        arcControlCoords[0],
        rotatePoint(
          arcControlCoords[0][0],
          arcControlCoords[0][1],
          arcControlCoords[1][0],
          arcControlCoords[1][1],
          -90,
        ),
      ];
      let arcControlFactor =
        dragcoords[0][0] === dragcoords[1][0] &&
        dragcoords[0][1] === dragcoords[1][1]
          ? 0
          : arcPower /
            Math.sqrt(
              Math.pow(
                Math.abs(arcControlCoords[0][0] - arcControlCoords[1][0]),
                2,
              ) +
                Math.pow(
                  Math.abs(arcControlCoords[0][1] - arcControlCoords[1][1]),
                  2,
                ),
            );
      arcControlCoords = [
        arcControlCoords[0],
        [
          arcControlCoords[0][0] +
            (arcControlCoords[1][0] - arcControlCoords[0][0]) *
              arcControlFactor,
          arcControlCoords[0][1] +
            (arcControlCoords[1][1] - arcControlCoords[0][1]) *
              arcControlFactor,
        ],
      ];
      let arcHeightCoords = [
        [dragcoords[1][0], dragcoords[1][1]],
        [
          (dragcoords[1][0] + dragcoords[0][0]) / 2,
          (dragcoords[1][1] + dragcoords[0][1]) / 2,
        ],
      ];
      arcHeightCoords = [
        arcHeightCoords[0],
        rotatePoint(
          arcHeightCoords[0][0],
          arcHeightCoords[0][1],
          arcHeightCoords[1][0],
          arcHeightCoords[1][1],
          -90,
        ),
      ];
      let arcHeightFactor =
        dragcoords[0][0] === dragcoords[1][0] &&
        dragcoords[0][1] === dragcoords[1][1]
          ? 0
          : arcHeight /
            Math.sqrt(
              Math.pow(
                Math.abs(arcHeightCoords[0][0] - arcHeightCoords[1][0]),
                2,
              ) +
                Math.pow(
                  Math.abs(arcHeightCoords[0][1] - arcHeightCoords[1][1]),
                  2,
                ),
            );
      arcHeightCoords = [
        arcHeightCoords[0],
        [
          arcHeightCoords[0][0] +
            (arcHeightCoords[1][0] - arcHeightCoords[0][0]) * arcHeightFactor,
          arcHeightCoords[0][1] +
            (arcHeightCoords[1][1] - arcHeightCoords[0][1]) * arcHeightFactor,
        ],
      ];
      let controlPoint = [arcControlCoords[1][0], arcControlCoords[1][1]];
      let arcArea =
        (calculateLength(dragcoords[0], dragcoords[1]) *
          calculateLength(arcControlCoords[0], arcControlCoords[1])) /
        2;
      perimeter =
        perimeter -
        calculateLength(points[x], points[x + 1]) +
        calculateLength(arcControlCoords[1], points[x]) * 2;
      if (inPolygon(controlPoint, points)) {
        area = area - arcArea;
      } else {
        area = area + arcArea;
      }
    }
  }
  return perimeter;
}

function calculateLength(start, target) {
  return Math.sqrt(
    Math.pow(Math.abs(start[0] - target[0]), 2) +
      Math.pow(Math.abs(start[1] - target[1]), 2),
  );
}

function rotatePoint(cx, cy, x, y, angle) {
  var radians = (Math.PI / 180) * angle,
    cos = Math.cos(radians),
    sin = Math.sin(radians),
    nx = cos * (x - cx) + sin * (y - cy) + cx,
    ny = cos * (y - cy) - sin * (x - cx) + cy;
  return [nx, ny];
}

function inPolygon(point, detail) {
  var inside = false;

  let vs = detail;
  var x = point[0],
    y = point[1];

  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    var xi = vs[i][0],
      yi = vs[i][1];
    var xj = vs[j][0],
      yj = vs[j][1];

    var intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }

  return inside;
}
